import { z } from 'zod'

/**
 * Zod schemas for matter member API responses.
 * Colocated with useManageMatterMembers — feature-specific, not shared with other matter operations.
 */

export enum AddMemberOutcome {
  INVITED = 'invited',
  ALREADY_INVITED = 'already_invited',
  ALREADY_MEMBER = 'already_member',
  NOT_FOUND = 'not_found',
}

/**
 * Represents a member of a matter (owner or collaborator).
 * Matches BE MatterMemberRead.
 */
export const MatterMemberReadSchema = z.object({
  user_id: z.string(),
  display_name: z.string().nullable(),
  email: z.string().nullable(),
  org_role: z.enum(['admin', 'user']).nullable(),
  matter_role: z.enum(['owner', 'collaborator', 'editor']),
  invited_at: z.string().nullable(),
  accepted_at: z.string().nullable(),
})
export type MatterMemberRead = z.infer<typeof MatterMemberReadSchema>
export type MatterAssignableRole = 'collaborator' | 'editor'
export const MatterMembersResponseSchema = z.object({ members: z.array(MatterMemberReadSchema) })
export type MatterMembersResponse = z.infer<typeof MatterMembersResponseSchema>

/** Per-user outcome from adding members. Mirrors BE AddMatterMemberResult. */
export const AddMatterMemberResultSchema = z.object({
  user_id: z.string(),
  outcome: z.nativeEnum(AddMemberOutcome),
})
export type AddMatterMemberResult = z.infer<typeof AddMatterMemberResultSchema>

/** Response from POST /matter/{matter_id}/members — per-user results + updated member list. */
export const AddMatterMembersResponseSchema = z.object({
  results: z.array(AddMatterMemberResultSchema),
  members: z.array(MatterMemberReadSchema),
})
export type AddMatterMembersResponse = z.infer<typeof AddMatterMembersResponseSchema>
